import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What exactly are peptides and how do they work?",
    a: "Peptides are short chains of amino acids that act as signaling molecules in your body. They communicate with cells to trigger specific biological processes like tissue repair, hormone regulation, and immune function. Think of them as precise molecular messengers that tell your body to heal, grow, or optimize.",
  },
  {
    q: "Are peptide therapies safe?",
    a: "When prescribed and monitored by qualified physicians, peptide therapies have an excellent safety profile. Many peptides like BPC-157 and Thymosin Alpha-1 have been extensively studied in clinical trials. Side effects are typically minimal and temporary. We conduct thorough health assessments before any treatment begins.",
  },
  {
    q: "How quickly will I see results?",
    a: "Results vary by peptide and individual, but many patients report noticeable improvements within 2-4 weeks. Weight management peptides often show results in the first month, while anti-aging and recovery peptides may take 6-8 weeks for full effects. We track your progress with regular check-ins and lab work.",
  },
  {
    q: "Do I need a prescription for peptide therapy?",
    a: "Yes, all our peptide therapies are prescribed by licensed physicians after a comprehensive health evaluation. This ensures you receive the right peptides at the right dosages for your unique health profile and goals. We handle the entire prescription and fulfillment process.",
  },
  {
    q: "Can peptides be combined for better results?",
    a: "Absolutely. Many of our patients benefit from carefully curated peptide stacks that target multiple health goals simultaneously. For example, combining BPC-157 for recovery with GHK-Cu for anti-aging can produce synergistic benefits. Our physicians design custom protocols based on your needs.",
  },
  {
    q: "What's the difference between peptide therapy and traditional medicine?",
    a: "Peptide therapy works with your body's natural processes rather than overriding them. Unlike many pharmaceuticals, peptides enhance your body's existing biological mechanisms. They're highly targeted, meaning fewer side effects and more precise results. It's the future of personalized, regenerative medicine.",
  },
  {
    q: "How are the peptides administered?",
    a: "Most peptides are administered via subcutaneous injection (similar to an insulin shot) which patients easily do at home. Some peptides are available as nasal sprays or oral formulations. During your consultation, we'll determine the best administration method for your comfort and results.",
  },
];

export default function FAQSection() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="mb-16 text-center"
        >
          <span className="text-xs md:text-sm font-sans font-medium uppercase tracking-[0.2em] text-[#C47C5D] mb-4 block">
            Common Questions
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-light tracking-tight text-[#2A3324]">
            Frequently Asked
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-[#2A3324]/10 py-2"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-xl md:text-2xl font-serif font-normal text-[#2A3324] text-left hover:no-underline py-6 [&[data-state=open]]:text-[#5C715E]"
                >
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-base font-sans font-light leading-relaxed text-[#2A3324]/70 pb-6">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
